import { FormGroup } from '@angular/forms';

// Krupa Shah : Create Validator for compare Password and Confirm password
export class RegistrationValidator {
    static validate(registrationFormGroup: FormGroup) {
        let password = registrationFormGroup.controls.Password.value;
        let repeatPassword = registrationFormGroup.controls.ConfPassword.value;

        if (repeatPassword == null || repeatPassword.length <= 0) {
            return null;
        }

        if (password != null && password != undefined &&
            repeatPassword != null && repeatPassword != undefined &&
            repeatPassword != password) {

            return {
                doesMatchPassword: true
            };
        }

        return null;

    }
}
